"use strict";
var TargetType;
(function (TargetType) {
    TargetType[TargetType["ConstructorArgument"] = 0] = "ConstructorArgument";
    TargetType[TargetType["ClassProperty"] = 1] = "ClassProperty";
})(TargetType || (TargetType = {}));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TargetType;



//////////////////
// WEBPACK FOOTER
// ./~/inversify/lib/planning/target_type.js
// module id = 24
// module chunks = 0